
<router-outlet></router-outlet>

<span id="transfers-mobile-size"></span>
<span id="transfers-tablet-size"></span>
<span id="transfers-desktop-size"></span>
<span id="transfers-bigdesktop-size"></span>